import React from 'react';
import useWhatsappStore from '~/store/whatsappStore';
import AIAssistant from '../Components/AIAssistant';
import ChefBotPromo from '../Components/ChefBotPromo';

export default function AITab() {
  const { planType } = useWhatsappStore();

  // If planType is BASIC_AUTOMATION, show promotional card
  if (planType === 'BASIC_AUTOMATION') {
    return <ChefBotPromo />;
  }

  // If planType is AI_AGENTS, show enabled AI assistant
  if (planType === 'AI_AGENTS') {
    return (
      <div>
        <AIAssistant showConnectionStatus />
        <ChefBotPromo />
      </div>
    );
  }

  // For other plans or when planType is not loaded, show disabled state
  return <AIAssistant disabled showConnectionStatus />;
}
